/*
 * Swift Ink — Bundle & Save pill enhancer
 * ------------------------------------------------------------
 * The homepage section renders the artwork, CTA and dual chip labels
 * server-side. The copy on the shop page lives inside
 * main-collection-product-grid.liquid, which is left untouched (it holds the
 * AMP cart hooks), so this script brings that one up to match.
 *
 * The pill is a <button data-bundle-builder-open>. Everything injected is a
 * plain inert <span>, so clicks still bubble to the button and the bundle
 * builder opens exactly as before.
 */
(function () {
  'use strict';

  var CFG = window.SwiftInkBundlePill || {};
  if (!CFG.image) return;

  // "Buy 3 Get 1 Free" -> "3+1 FREE". Falls back to the original text if the
  // wording ever changes shape.
  function shorten(text) {
    var m = text.match(/(\d+)\D+(\d+)/);
    if (!m) return text;
    return m[1] + '+' + m[2] + (/free/i.test(text) ? ' FREE' : '');
  }

  function dualLabels(pill) {
    var tiers = pill.querySelectorAll('.si-bpill__tier');

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      if (tier.querySelector('.si-bpill__short')) continue;

      var text = (tier.textContent || '').trim();
      if (!text) continue;

      var long = document.createElement('span');
      long.className = 'si-bpill__long';
      long.textContent = text;

      var short = document.createElement('span');
      short.className = 'si-bpill__short';
      short.textContent = shorten(text);

      tier.textContent = '';
      tier.appendChild(long);
      tier.appendChild(short);
    }
  }

  function decorate(root) {
    var pills = (root || document).querySelectorAll('.si-bpill');

    for (var i = 0; i < pills.length; i++) {
      var pill = pills[i];

      if (!pill.querySelector('.si-bpill__glow')) {
        var glow = document.createElement('span');
        glow.className = 'si-bpill__glow';
        glow.setAttribute('aria-hidden', 'true');
        pill.insertBefore(glow, pill.firstChild);
      }

      if (!pill.querySelector('.si-bpill__thumb')) {
        var thumb = document.createElement('span');
        thumb.className = 'si-bpill__thumb';

        var img = document.createElement('img');
        img.src = CFG.image;
        img.alt = '';
        img.setAttribute('loading', 'lazy');
        img.setAttribute('width', '200');
        img.setAttribute('height', '200');
        thumb.appendChild(img);

        var body = pill.querySelector('.si-bpill__body');
        if (body) pill.insertBefore(thumb, body);
        else pill.appendChild(thumb);
      }

      if (!pill.querySelector('.si-bpill__cta')) {
        var cta = document.createElement('span');
        cta.className = 'si-bpill__cta';
        cta.textContent = CFG.cta || 'Free tattoos';

        var chevron = pill.querySelector('.si-bpill__chevron');
        if (chevron) pill.insertBefore(cta, chevron);
        else pill.appendChild(cta);
      }

      dualLabels(pill);
    }
  }

  function boot() {
    decorate(document);

    var dyn = document.getElementById('si-dynamic');
    if (dyn && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        setTimeout(function () {
          queued = false;
          decorate(dyn);
        }, 80);
      }).observe(dyn, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
